// Copyright (c) 2016 Deere & Company

import './index.scss';
import React, {PropTypes} from 'react';
import File from '@deere/cps-it.warranty-model-factory/lib/file';
import FileAttachmentSingle from './file-attachment-single';
import FileUpload from '../../../../shared/components/file-upload/file-upload';
import {FormattedMessage} from 'react-intl';

const doNothing = () => ({});

const FileAttachmentSinglePanel = props =>
    <section className='file-upload-panel'>
        <header>
            <FormattedMessage id='ATTACHMENTS'/>
        </header>
        <FileAttachmentSingle
            file={props.file}
            onFileDelete={props.onFileDelete}
        />
        {props.isUploadAllowed &&
            <FileUpload
                displayMessage={props.displayMessage}
                djsConfig={props.djsConfig}
                handleFileDelete={doNothing}
                handleFileUploadSuccess={props.onFileUploadSuccess}
                isRequired={props.isRequired}
                serviceConfig={props.serviceConfig}
            />
        }
    </section>;

FileAttachmentSinglePanel.displayName = 'FileAttachmentSinglePanel';

FileAttachmentSinglePanel.propTypes = {
    displayMessage: PropTypes.string,
    djsConfig: PropTypes.object,
    file: PropTypes.instanceOf(File).isRequired,
    isRequired: PropTypes.bool,
    isUploadAllowed: PropTypes.bool.isRequired,
    onFileDelete: PropTypes.func.isRequired,
    onFileUploadSuccess: PropTypes.func.isRequired,
    serviceConfig: PropTypes.shape({
        className: PropTypes.string.isRequired,
        classType: PropTypes.string.isRequired,
        objectKey: PropTypes.string.isRequired
    })
};
FileAttachmentSinglePanel.defaultProps = {
    djsConfig: {},
    isRequired: false,
    isUploadAllowed: true
};

export default FileAttachmentSinglePanel;



// WEBPACK FOOTER //
// ./src/claim/shared/components/file-attachment-single-panel/index.js